import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, deleteApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ExcluirLocalidadesRelacionadasRequest } from './types';

// ACTIONS
import {
	excluirLocalidadesRelacionadasSuccess,
	excluirLocalidadesRelacionadasFailure,
} from './actions';

function* excluirLocalidadeRelacionada(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ExcluirLocalidadesRelacionadasRequest } =
		request;

	const response: ApiResponse = yield call(
		deleteApi,
		token || '',
		PATH_SGU_API,
		`localidades-usuarios/${payload.id}`,
	);

	if (response.status === 200) {
		response.data = {
			id: payload.id,
		};
		yield put(excluirLocalidadesRelacionadasSuccess(response));
	} else {
		yield put(excluirLocalidadesRelacionadasFailure());
	}
}

export default all([
	takeLatest(
		Types.EXCLUIR_LOCALIDADES_RELACIONADAS,
		excluirLocalidadeRelacionada,
	),
]);
